<app-navbar />

<div class="container-fluid">
  <!-- Filtros -->
  <div class="card shadow-sm filtros-modernas border-0 mb-4">
    <div class="card-header d-flex align-items-center rounded-top">
      <i class="fas fa-search fs-5 me-2"></i>
      <h2 class="fw-bold">Todas Vistorias</h2>
    </div>
    <div class="card-body">

      <!-- Linha com botão de filtro à esquerda e controles de paginação/itens por página à direita -->
      <div class="row mt-3" *ngIf="!erro">
        <div class="top-controls compact-controls d-flex flex-wrap align-items-center justify-content-between">
          <div class="d-flex gap-2">
            <button class="btn btn-info btn-sm" type="button" (click)="toggleFiltros()">
              <i class="fas fa-filter me-1"></i> Filtrar
            </button>
            <button class="btn btn-success btn-sm" type="button" (click)="exportarParaExcel()" 
                    [disabled]="servicosFiltrados.length === 0"
                    title="Exportar dados filtrados para Excel">
              <i class="fas fa-file-excel me-1"></i> Exportar Excel
            </button>
          </div>

          <!-- Período -->
          <div class="d-flex align-items-center gap-2 me-3">
            <input class="form-control form-control-sm period-input" type="date" [(ngModel)]="filtroDataInicio" />
            <span>até</span>
            <input class="form-control form-control-sm period-input" type="date" [(ngModel)]="filtroDataFim"
              (change)="onFiltroDataFimChange()" />
          </div>

          <div>
            <button class="btn btn-primary" (click)="aplicarFiltro()">Recarregar</button>
          </div>

          <!-- Itens por página + Paginação -->
          <div class="d-flex align-items-center gap-2 ms-auto">
            <label class="mb-0 small">Itens:</label>
            <select id="tamanhoPaginaSelect" class="form-select form-select-sm" [(ngModel)]="tamanhoPagina"
              (ngModelChange)="alterarTamanhoPagina($event)">
              <option [ngValue]="5">5</option>
              <option [ngValue]="10">10</option>
              <option [ngValue]="25">25</option>
              <option [ngValue]="50">50</option>
              <option [ngValue]="100">100</option>
              <option [ngValue]="-1">Todos</option>
            </select>

            <span class="page-info small">
              Página {{paginaAtual}} de {{totalPaginas}} ({{totalItens}} itens)
            </span>

            <!-- Botões -->
            <button class="btn btn-outline-secondary btn-sm" (click)="paginaAnterior()" [disabled]="paginaAtual <= 1">
              <i class="fas fa-chevron-left"></i>
            </button>
            <button class="btn btn-outline-secondary btn-sm" (click)="proximaPagina()"
              [disabled]="paginaAtual >= totalPaginas">
              <i class="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>

      </div>

      <div class="row mt-2" *ngIf="showFiltros">
        <div class="col-md-3">
          <label class="form-label">Status</label>
          <select class="form-select" [(ngModel)]="filtroStatus">
            <option value="">Todos</option>
            <option value="EmAndamento">EmAndamento</option>
            <option value="Concluida">Concluido</option>
            <option value="Retornar">Retornar</option>
            <option value="Negada">Negado</option>
            <option value="Validado">Validado</option>
            <option value="Invalido">Invalido</option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label">Matrícula</label>
          <input type="text" class="form-control" [(ngModel)]="filtroMatricula" placeholder="Matrícula do consumidor" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Nº Vistoria</label>
          <!-- ao alterar o campo, notificar componente para busca debounced na API -->
          <input type="text" class="form-control" [(ngModel)]="filtroNumeroVistoria"
            (ngModelChange)="onNumeroVistoriaInputChanged($event)" placeholder="Nº Vistoria" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Nome Consumidor</label>
          <input type="text" class="form-control" [(ngModel)]="filtroNomeConsumidor" placeholder="Nome do consumidor" />
        </div>
        <div class="col-md-3">
          <label class="form-label">CPF</label>
          <input type="text" class="form-control" [(ngModel)]="filtroCpf" placeholder="CPF" />
        </div>
        <div class="col-md-3">
          <label class="form-label">CNPJ</label>
          <input type="text" class="form-control" [(ngModel)]="filtroCnpj" placeholder="CNPJ" />
        </div>
        <div class="col-md-3">
          <label class="form-label">CEP</label>
          <input type="text" class="form-control" [(ngModel)]="filtroCep" placeholder="CEP" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Número</label>
          <input type="text" class="form-control" [(ngModel)]="filtroNumero" placeholder="Número (logradouro)" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Logradouro</label>
          <input type="text" class="form-control" [(ngModel)]="filtroLogradouro" placeholder="Logradouro" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Bairro</label>
          <input type="text" class="form-control" [(ngModel)]="filtroBairro" placeholder="Bairro" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Cidade</label>
          <input type="text" class="form-control" [(ngModel)]="filtroCidade" placeholder="Cidade" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Estado</label>
          <input type="text" class="form-control" [(ngModel)]="filtroEstado" placeholder="Estado" />
        </div>
        <div class="col-12 mt-2 d-flex gap-2">
          <button class="btn btn-primary" (click)="aplicarFiltro()">Aplicar filtros</button>
          <button class="btn btn-secondary" (click)="resetarERecarregar()">Limpar e Recarregar</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Estados -->
  <div *ngIf="erro" class="alert alert-danger d-flex align-items-center gap-2">
    <i class="bi bi-exclamation-triangle-fill"></i> {{ erro }}
  </div>

  <div *ngIf="servicosFiltrados.length === 0 && (filtroUsuarioId || (!filtroUsuarioId && servicos.length === 0))"
    class="alert alert-warning d-flex align-items-center gap-2">
    <i class="bi bi-folder-x"></i> Nenhuma vistoria encontrada {{ filtroUsuarioId ? 'no período' : '' }}.
  </div>

  <!-- Tabela de Vistoria -->
  <div class="table-responsive" *ngIf="servicosFiltrados.length > 0">
    <table class="table table-bordered table-hover align-middle">
      <thead class="table-light">
        <tr>
          <th>Data</th>
          <th style="min-width: 110px;">Nº Vistoria</th>
          <th>Consumidor</th>
          <th style="min-width: 130px;">CPF/CNPJ</th>
          <th style="min-width: 120px;">Tipo Vistoria</th>
          <th>Endereço</th>
          <th>Status</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let servico of servicosFiltrados; let i = index; trackBy: trackById"
          [class]="i % 2 === 0 ? 'linha-par' : 'linha-impar'">
          <td>
            <span class="text-primary fw-bold">
              {{ servico.dataServico | date: 'dd/MM/yyyy' }}
            </span>
          </td>
          <td>
            <span class=" n-vistoria" title="{{ formatNumeroOS(servico) }}">{{ formatNumeroOS(servico) }}</span>
          </td>
          <td>
            <span class="fw-bold text-dark">
              <i class="bi bi-person-circle me-1 text-info"></i>
              {{ servico.nomeConsumidor }}
            </span>
          </td>
          <td>
            <span class="badge text-dark badge-campo-doc d-flex align-items-center gap-1">
              <i class="bi bi-file-earmark-person"></i>
              <!-- Show CPF for domiciliar, otherwise show CNPJ when available. Prefer explicit consumidor fields if present. -->
              {{
              (servico.tipoUtilizacao?.toLowerCase() === 'DOMICILIAR')
              ? (servico.cpfConsumidor || servico.cpf || servico.cpfCnpj ? maskCpf(servico.cpfConsumidor || servico.cpf
              || servico.cpfCnpj) : '-')
              : (servico.cnpjConsumidor || servico.cpfCnpj || servico.cnpj ? maskCnpj(servico.cnpjConsumidor ||
              servico.cpfCnpj || servico.cnpj) : '-'
              )
              }}
            </span>
          </td>
          <td>
            <span class="badge"
              [ngClass]="getTipoServico(servico) === 'recadastro' ? 'recadastro-badge' : 'cadastro-badge'">
              {{ getTipoServico(servico) }}
            </span>
          </td>
          <td>
            <span *ngIf="servico.endereco || servico.logradouro" class="text-secondary" style="font-size:12px;">
              {{ getEnderecoCompleto(servico) }}
            </span>
            <span *ngIf="!servico.endereco && !servico.logradouro" class="text-muted">-</span>
          </td>
          <td>
            <div class="status-wrapper d-flex align-items-center justify-content-center flex-column">
              <i class="status-icon" [ngClass]="statusClasses(servico)"
                [title]="effectiveStatus(servico) || 'Status não definido'"></i>
              <!-- Texto explicativo quando em análise -->
              <small *ngIf="effectiveStatus(servico).toLowerCase() === 'analisando'"
                class="status-label text-analisando">Analisando</small>
            </div>
          </td>
          <td>
            <button class="btn btn-outline-primary btn-xs px-2 py-1" style="font-size:0.95rem;"
              (click)="verDetalhes(servico)">
              <i class="bi bi-eye me-1"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Spinner de carregamento -->
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="timer" [fullScreen]="true">
  <p style="color: white"> Processando, por favor aguarde... </p>
</ngx-spinner>

<div class="modal fade show" tabindex="-1" *ngIf="servicoDetalhes">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content" #conteudoModal>
      <div class="modal-header bg-gradient-info text-white">
        <h5 class="modal-title">
          <i class="bi bi-file-earmark-text me-2"></i>
          Detalhes da Vistoria
        </h5>
        <button type="button" class="btn-close" (click)="fecharModalDetalhes()"></button>
      </div>
      <div class="modal-body">
        <form class="form px-2 py-2">

          <div class="mb-3">
            <div class="p-3 rounded bg-gradient-info d-flex align-items-center">
              <i class="fas fa-search fs-4 me-3"></i>
              <div>
                <div class="small">Vistoria</div>
                <div class="h5 fw-bold mb-0">n° {{ formatNumeroOS(servicoDetalhes) }}</div>
              </div>
            </div>
          </div>

          <fieldset>
            <legend class="mb-2">Dados do Consumidor</legend>
            <div class="grid-2 mb-2 texto">
              <div *ngIf="getTipoServico(servicoDetalhes) === 'recadastro' && servicoDetalhes.matricula">
                <label>Matrícula</label>
                <input type="text" [value]="servicoDetalhes.matricula" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Nome do Consumidor</label>
                <input type="text" [value]="servicoDetalhes.nomeConsumidor || '-'" readonly class="campo-readonly" />
              </div>
              <div>
                <label>
                  <ng-container *ngIf="servicoDetalhes.tipoUtilizacao === 'DOMICILIAR'; else cnpjLabel">
                    CPF
                  </ng-container>
                  <ng-template #cnpjLabel>CNPJ</ng-template>
                </label>
                <input type="text"
                  [value]="servicoDetalhes.tipoUtilizacao === 'DOMICILIAR' ? maskCpf(servicoDetalhes.cpf) : maskCnpj(servicoDetalhes.cnpj)"
                  readonly class="campo-readonly" />
              </div>
            </div>

            <div class="grid-4 mb-2">
              <div *ngIf="servicoDetalhes.email">
                <label>Email</label>
                <input type="text" [value]="servicoDetalhes.email || '-'" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Telefone</label>
                <input type="text" [value]="maskTelefone(servicoDetalhes.telefone)" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Ciclo de Leitura</label>
                <input type="text" [value]="servicoDetalhes.cicloDeLeitura || '-'" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Número Imóvel</label>
                <input type="text" [value]="servicoDetalhes.numeroImovel || '-'" readonly class="campo-readonly" />
              </div>
            </div>

            <div class="grid-4 mb-2">
              <div>
                <label>Referência</label>
                <input type="text" [value]="servicoDetalhes.referencia || '-'" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Data Cadastro</label>
                <input type="text" [value]="servicoDetalhes.dataHoraInicio | date: 'dd/MM/yyyy HH:mm'" readonly
                  class="campo-readonly" />
              </div>
              <div>
                <label>Loja/Loc</label>
                <input type="text" [value]="servicoDetalhes.lojLoc || '-'" readonly class="campo-readonly" />
              </div>
            </div>

            <div class="grid-3 mb-2">
              <div>
                <label>Sistema de Abastecimento</label>
                <input type="text" [value]="servicoDetalhes.sistemaAbastecimento || '-'" readonly
                  class="campo-readonly" />
              </div>
              <div>
                <label>Tipo de Abastecimento</label>
                <input type="text" [value]="servicoDetalhes.tipoAbastecimento || '-'" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Tipo Utilização</label>
                <input type="text" [value]="servicoDetalhes.tipoUtilizacao || '-'" readonly class="campo-readonly" />
              </div>
            </div>
          </fieldset>

          <fieldset
            *ngIf="servicoDetalhes.numeroHidrometro || servicoDetalhes.marcacao || servicoDetalhes.seloReloj || servicoDetalhes.seloVirola || servicoDetalhes.ramal || servicoDetalhes.direto !== undefined || servicoDetalhes.haCisterna !== undefined || servicoDetalhes.haReservatorioElevado !== undefined || servicoDetalhes.tipoEconomia || servicoDetalhes.haPiscina !== undefined">
            <legend class="mb-2">ÁGUA</legend>
            <div class="grid-3 mb-2">
              <div>
                <label>Nº Hidrômetro</label>
                <input type="text" [value]="servicoDetalhes.numeroHidrometro || '-'" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Marcação</label>
                <input type="text" [value]="servicoDetalhes.marcacao || '-'" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Selo Reloj.</label>
                <input type="text" [value]="servicoDetalhes.seloReloj || '-'" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Selo Virola</label>
                <input type="text" [value]="servicoDetalhes.seloVirola || '-'" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Ramal</label>
                <input type="text" [value]="servicoDetalhes.ramal || '-'" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Direto</label>
                <input type="text"
                  [value]="servicoDetalhes.direto === undefined ? '-' : (servicoDetalhes.direto ? 'Sim' : 'Não')"
                  readonly class="campo-readonly" />
              </div>
            </div>

            <div class="grid-1 mb-2">

              <fieldset *ngIf="servicoDetalhes.haCisterna !== undefined">
                <h4>Cisterna</h4>
                <label>Há cisterna?</label>
                <input type="text" [value]="servicoDetalhes.haCisterna ? 'Sim' : 'Não'" readonly
                  class="campo-readonly" />
                <div *ngIf="servicoDetalhes.haCisterna && servicoDetalhes.capacidadeCisternaInformada">
                  <label>Capacidade Informada</label>
                  <input type="text" [value]="servicoDetalhes.capacidadeCisternaInformada" readonly
                    class="campo-readonly" />
                </div>
                <div *ngIf="servicoDetalhes.haCisterna && servicoDetalhes.observacoesCisterna">
                  <label>Observações</label>
                  <textarea readonly class="campo-readonly"
                    rows="2">{{ servicoDetalhes.observacoesCisterna }}</textarea>
                </div>
              </fieldset>

              <fieldset *ngIf="servicoDetalhes.haReservatorioElevado !== undefined">
                <h4>Reservatório Elevado</h4>
                <label>Há Reservatórios Elevados?</label>
                <input type="text" [value]="servicoDetalhes.haReservatorioElevado ? 'Sim' : 'Não'" readonly
                  class="campo-readonly" />
                <div
                  *ngIf="servicoDetalhes.haReservatorioElevado && servicoDetalhes.capacidadeReservatorioElevadoInformada">
                  <label>Capacidade Informada</label>
                  <input type="text" [value]="servicoDetalhes.capacidadeReservatorioElevadoInformada" readonly
                    class="campo-readonly" />
                </div>
                <div *ngIf="servicoDetalhes.haReservatorioElevado && servicoDetalhes.observacoesReservatorioElevado">
                  <label>Observações</label>
                  <textarea readonly class="campo-readonly"
                    rows="2">{{ servicoDetalhes.observacoesReservatorioElevado }}</textarea>
                </div>
              </fieldset>

              <fieldset *ngIf="servicoDetalhes.haPiscina !== undefined">
                <h4>Piscina</h4>
                <label>Existe Piscina?</label>
                <input type="text" [value]="servicoDetalhes.haPiscina ? 'Sim' : 'Não'" readonly
                  class="campo-readonly" />
                <div *ngIf="servicoDetalhes.haPiscina && servicoDetalhes.dimensoesPiscina">
                  <label>Dimensões:</label>
                  <input type="text" [value]="servicoDetalhes.dimensoesPiscina" readonly class="campo-readonly" />
                </div>
              </fieldset>
            </div>
          </fieldset>

          <fieldset>
            <legend class="mb-2">Economias</legend>
            <div class="grid-3 mb-2">
              <div>
                <label>Tipos de Economias</label>
                <input type="text" [value]="servicoDetalhes.tipoEconomia || '-'" readonly class="campo-readonly" />
              </div>
              <div *ngIf="servicoDetalhes.dUnica">
                <label>Sub Categoria</label>
                <input type="text" [value]="servicoDetalhes.dUnica" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Número de Economias</label>
                <input type="text" [value]="servicoDetalhes.numeroDeEconomias || '-'" readonly class="campo-readonly" />
              </div>
            </div>

            <!-- Domiciliar -->
            <div class="grid-4 mb-2" *ngIf="servicoDetalhes.tipoEconomia === 'DOMICILIAR' ">
              <div>
                <label>Nº Quartos</label>
                <input type="text" [value]="servicoDetalhes.numeroDeQuartos" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Nº Salas</label>
                <input type="text" [value]="servicoDetalhes.numeroDeSalas" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Nº WC/PAV</label>
                <input type="text" [value]="servicoDetalhes.numeroWcPav" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Nº Boxes</label>
                <input type="text" [value]="servicoDetalhes.numeroDeBoxes" readonly class="campo-readonly" />
              </div>
               <div>
                <label>Nº Banheiro</label>
                <input type="text" [value]="servicoDetalhes.banheiros" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Área (m²)</label>
                <input type="text" [value]="servicoDetalhes.areaMetroQuadrado" readonly class="campo-readonly" />
              </div>
            </div>

            <!-- COMERCIO -->
            <div class="grid-3 mb-2" *ngIf="servicoDetalhes.tipoEconomia === 'COMERCIO'">
              <div>
                <label>Nº Salas/Lojas/Quartos</label>
                <input type="text" [value]="servicoDetalhes.numeroDeQuartos" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Tipo Comércio</label>
                <input type="text" [value]="servicoDetalhes.tipoComercio" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Alunos</label>
                <input type="text" [value]="servicoDetalhes.numeroDeAlunos" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Nº Boxes</label>
                <input type="text" [value]="servicoDetalhes.numeroDeBoxes" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Nº Banheiro</label>
                <input type="text" [value]="servicoDetalhes.banheiros" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Área (m²)</label>
                <input type="text" [value]="servicoDetalhes.areaMetroQuadrado" readonly class="campo-readonly" />
              </div>
            </div>
            <!-- Indústria -->
            <div class="grid-3 mb-2"
              *ngIf="servicoDetalhes.tipoEconomia === 'INDUSTRIA'">
              <div>
                <label>Tipo Indústria</label>
                <input type="text" [value]="servicoDetalhes.tipoIndustria" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Área (m²)</label>
                <input type="text" [value]="servicoDetalhes.areaMetroQuadrado" readonly class="campo-readonly" />
              </div>
            </div>
          </fieldset>

          <fieldset>
            <legend class="mb-2">ESGOTO</legend>
            <div>
              <label>Tem coletor?</label>
              <input type="text" [value]="servicoDetalhes.haColetor ? 'Sim' : 'Não'" readonly class="campo-readonly" />
            </div>

            <div *ngIf="servicoDetalhes.haColetor">
              <label>Efluente encaminhado para:</label>
              <div class="grid-4 mb-2">
                <div *ngIf="servicoDetalhes.coletor === 'true'">
                  <label>Coletor</label>
                  <input type="text" value="Sim" readonly class="campo-readonly" />
                </div>
                <div *ngIf="servicoDetalhes.gap === 'true'">
                  <label>GAP</label>
                  <input type="text" value="Sim" readonly class="campo-readonly" />
                </div>
                <div *ngIf="servicoDetalhes.rio === 'true'">
                  <label>RIO</label>
                  <input type="text" value="Sim" readonly class="campo-readonly" />
                </div>
                <div *ngIf="servicoDetalhes.valao === 'true'">
                  <label>VALÃO</label>
                  <input type="text" value="Sim" readonly class="campo-readonly" />
                </div>
                <div *ngIf="servicoDetalhes.focaFiltro === 'true'">
                  <label>Fossa/Filtro</label>
                  <input type="text" value="Sim" readonly class="campo-readonly" />
                </div>
                <div *ngIf="servicoDetalhes.vala === 'true'">
                  <label>Vala</label>
                  <input type="text" value="Sim" readonly class="campo-readonly" />
                </div>
                <div *ngIf="servicoDetalhes.sumidouro === 'true'">
                  <label>Sumidouro</label>
                  <input type="text" value="Sim" readonly class="campo-readonly" />
                </div>
              </div>
              <div *ngIf="servicoDetalhes.tipoValaValao">
                <label>A vala ou valão é de:</label>
                <input type="text" [value]="servicoDetalhes.tipoValaValao" readonly class="campo-readonly" />
              </div>
            </div>
          </fieldset>

          <fieldset>
            <legend class="mb-2">Endereço</legend>
            <div class="grid-3 mb-2">
              <div>
                <label>Logradouro:</label>
                <input type="text" class="form-control campo-readonly"
                  [value]="servicoDetalhes.endereco?.logradouro || servicoDetalhes.logradouro || '-'" readonly>
              </div>
              <div>
                <label>Número:</label>
                <input type="text" class="form-control campo-readonly"
                  [value]="servicoDetalhes.endereco?.numero || servicoDetalhes.numero || '-'" readonly>
              </div>
              <div>
                <label>Bairro:</label>
                <input type="text" class="form-control campo-readonly"
                  [value]="servicoDetalhes.endereco?.bairro || servicoDetalhes.bairro || '-'" readonly>
              </div>
            </div>
            <div class="grid-3 mb-2">
              <div>
                <label>Cidade:</label>
                <input type="text" class="form-control campo-readonly"
                  [value]="servicoDetalhes.endereco?.cidade || servicoDetalhes.cidade || '-'" readonly>
              </div>
              <div>
                <label>Estado:</label>
                <input type="text" class="form-control campo-readonly"
                  [value]="servicoDetalhes.endereco?.estado || servicoDetalhes.estado || '-'" readonly>
              </div>
              <div>
                <label>CEP:</label>
                <input type="text" class="form-control campo-readonly"
                  [value]="servicoDetalhes.endereco?.cep || servicoDetalhes.cep || '-'" readonly>
              </div>
            </div>
            <div class="grid-1 mb-2" *ngIf="servicoDetalhes.endereco?.complemento || servicoDetalhes.complemento">
              <div>
                <label>Complemento:</label>
                <input type="text" class="form-control campo-readonly"
                  [value]="servicoDetalhes.endereco?.complemento || servicoDetalhes.complemento || '-'" readonly>
              </div>
            </div>
          </fieldset>

          <fieldset>
            <legend class="mb-2">FOTOS DO LOCAL</legend>
            <div class="fotos-grid mb-2">
              <div class="foto-item" *ngFor="let foto of servicoDetalhes.fotos">
                <div class="foto-wrapper" style="display: flex; flex-direction: column; align-items: center;">
                  <img [src]="getFullImageUrl(foto.url)" alt="Foto do Local" class="foto-local"
                    [style.transform]="'rotate(' + getRotacaoMiniatura(foto.url) + 'deg)'"
                    [style.transition]="'transform 0.3s'" (click)="abrirModalFoto(foto.url)" />
                </div>
                <div class="foto-actions mt-2" style="display:flex;gap:8px;justify-content:center;">
                  <a *ngIf="foto?.latitude && foto?.longitude"
                    [href]="'https://www.google.com/maps?q=' + foto.latitude + ',' + foto.longitude" target="_blank"
                    class="btn btn-outline-success btn-sm">
                    <i class="bi bi-geo-alt-fill"></i>Mapa
                  </a>

                  <button *ngIf="isSuperAdministrador" type="button" class="btn btn-outline-danger btn-sm" title="Excluir foto"
                    (click)="$event.stopPropagation(); excluirFoto(foto)">
                    <i class="bi bi-trash"></i>
                  </button>

                  <div class="rotate-buttons">
                    <button type="button" class="btn btn-light btn-sm rotate-btn"
                      (click)="$event.stopPropagation(); girarMiniatura(foto.url, 'esquerda')" title="Girar esquerda">
                      <i class="bi bi-arrow-counterclockwise"></i>
                    </button>
                    <button type="button" class="btn btn-light btn-sm rotate-btn"
                      (click)="$event.stopPropagation(); girarMiniatura(foto.url, 'direita')" title="Girar direita">
                      <i class="bi bi-arrow-clockwise"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="!servicoDetalhes.fotos?.length" class="alert alert-warning">
              Nenhuma foto disponível.
            </div>
          </fieldset>

          <fieldset>
            <legend class="mb-2">OUTRAS INFORMAÇÕES</legend>
            <div *ngIf="servicoDetalhes.outrasInformacoes">
              <label>Descrição da Conclusão</label>
              <textarea readonly class="campo-readonly" rows="6">{{ servicoDetalhes.outrasInformacoes }}</textarea>
            </div>
          </fieldset>

          <fieldset *ngIf="servicoDetalhes.motivoNegativa">
            <legend class="mb-2">MOTIVO DA NEGATIVA</legend>
            <div class="grid-1 mb-2">
              <div>
                <label>Descrição da Negativa</label>
                <textarea readonly class="campo-readonly" rows="4">{{ servicoDetalhes.motivoNegativa }}</textarea>
              </div>
            </div>
          </fieldset>

          <fieldset *ngIf="servicoDetalhes.motivoInvalidacao">
            <legend class="mb-2">MOTIVO DA INVALIDAÇÃO</legend>
            <div class="grid-1 mb-2">
              <div>
                <label>Descrição da Invalidação</label>
                <textarea readonly class="campo-readonly" rows="4">{{ servicoDetalhes.motivoInvalidacao }}</textarea>
              </div>
            </div>
          </fieldset>

          <fieldset class="fotos">
            <legend class="mb-2">FOTOS DE DOCUMENTOS</legend>
            <div class="fotos-grid mb-2">
              <div class="foto-item" *ngFor="let fotoDoc of servicoDetalhes.fotosDocumento">
                <div class="foto-wrapper" style="display: flex; flex-direction: column; align-items: center;">
                  <img [src]="getFullImageUrl(fotoDoc.url)" alt="Foto do Documento" class="foto-local"
                    [style.transform]="'rotate(' + getRotacaoMiniatura(fotoDoc.url) + 'deg)'"
                    [style.transition]="'transform 0.3s'" (click)="abrirModalFoto(fotoDoc.url)" />
                </div>
                <div class="foto-actions mt-2" style="display:flex;gap:8px;justify-content:center;">
                  <a *ngIf="fotoDoc?.latitude && fotoDoc?.longitude"
                    [href]="'https://www.google.com/maps?q=' + fotoDoc.latitude + ',' + fotoDoc.longitude"
                    target="_blank" class="btn btn-outline-success btn-sm">
                    <i class="bi bi-geo-alt-fill"></i>Mapa
                  </a>

                  <button *ngIf="isSuperAdministrador" type="button" class="btn btn-outline-danger btn-sm" title="Excluir documento"
                    (click)="$event.stopPropagation(); excluirFotoDocumento(fotoDoc)">
                    <i class="bi bi-trash"></i>
                  </button>

                  <div class="rotate-buttons">
                    <button type="button" class="btn btn-light btn-sm rotate-btn"
                      (click)="$event.stopPropagation(); girarMiniatura(fotoDoc.url, 'esquerda')" title="Girar esquerda">
                      <i class="bi bi-arrow-counterclockwise"></i>
                    </button>
                    <button type="button" class="btn btn-light btn-sm rotate-btn"
                      (click)="$event.stopPropagation(); girarMiniatura(fotoDoc.url, 'direita')" title="Girar direita">
                      <i class="bi bi-arrow-clockwise"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="!servicoDetalhes.fotosDocumento?.length" class="alert alert-warning">
              Nenhuma foto disponível.
            </div>
          </fieldset>


          <fieldset>
            <legend class="mb-2">Localização</legend>
            <div class="grid-2 mb-2">
              <div>
                <label>Início</label>
                <div *ngIf="servicoDetalhes.latitudeInicio && servicoDetalhes.longitudeInicio"
                  class="coordenadas-label">
                  <span class="badge bg-light text-dark">Lat: {{ servicoDetalhes.latitudeInicio }} | Lng: {{
                    servicoDetalhes.longitudeInicio }}</span>
                </div>
                <a *ngIf="servicoDetalhes.latitudeInicio && servicoDetalhes.longitudeInicio"
                  [href]="'https://www.google.com/maps?q=' + servicoDetalhes.latitudeInicio + ',' + servicoDetalhes.longitudeInicio"
                  target="_blank" class="btn btn-outline-success btn-sm ms-1">
                  <i class="bi bi-geo-alt-fill"></i> Ver no mapa
                </a>
                <span *ngIf="!servicoDetalhes.latitudeInicio || !servicoDetalhes.longitudeInicio" class="text-muted">Sem
                  localização</span>
                <div class="mt-2">
                  <label>Data/Hora Início</label>
                  <input type="text" [value]="servicoDetalhes.dataHoraInicio | date:'dd/MM/yyyy HH:mm:ss'" readonly
                    class="campo-readonly" />
                </div>
              </div>
              <div>
                <label>Fim</label>
                <div *ngIf="servicoDetalhes.latitudeFim && servicoDetalhes.longitudeFim" class="coordenadas-label">
                  <span class="badge bg-light text-dark">Lat: {{ servicoDetalhes.latitudeFim }} | Lng: {{
                    servicoDetalhes.longitudeFim }}</span>
                </div>
                <a *ngIf="servicoDetalhes.latitudeFim && servicoDetalhes.longitudeFim"
                  [href]="'https://www.google.com/maps?q=' + servicoDetalhes.latitudeFim + ',' + servicoDetalhes.longitudeFim"
                  target="_blank" class="btn btn-outline-danger btn-sm ms-1">
                  <i class="bi bi-geo-alt-fill"></i> Ver no mapa
                </a>
                <span *ngIf="!servicoDetalhes.latitudeFim || !servicoDetalhes.longitudeFim" class="text-muted">Sem
                  localização</span>
                <div class="mt-2">
                  <label>Data/Hora Fim</label>
                  <input type="text" [value]="servicoDetalhes.dataHoraFim | date:'dd/MM/yyyy HH:mm:ss'" readonly
                    class="campo-readonly" />
                </div>
              </div>
            </div>
            <div class="map-container">
              <div id="map-servico" *ngIf="servicoDetalhes"></div>
            </div>
          </fieldset>

          <fieldset>
            <legend class="mb-2">Acompanhante</legend>
            <div class="grid-3 mb-2">
              <div>
                <label>Nome:</label>
                <input type="text" class="form-control campo-readonly" [value]="servicoDetalhes.nomeAcompanhante || '-'"
                  readonly>
              </div>
              <div>
                <label>CPF:</label>
                <input type="text" class="form-control campo-readonly"
                  [value]="servicoDetalhes.cpfAcompanhante ? maskCpf(servicoDetalhes.cpfAcompanhante) : '-'" readonly>
              </div>
              <div>
                <label>Telefone:</label>
                <input type="text" class="form-control campo-readonly"
                  [value]="servicoDetalhes.telefoneAcompanhante ? maskTelefone(servicoDetalhes.telefoneAcompanhante) : '-'"
                  readonly>
              </div>
            </div>
            <div>
              <label>Assinatura do Acompanhante:</label>
              <div class="signature-container">
                <img *ngIf="servicoDetalhes.assinaturaAcompanhante?.url || servicoDetalhes.assinaturaAcompanhante"
                  [src]="getFullImageUrl(servicoDetalhes.assinaturaAcompanhante?.url || servicoDetalhes.assinaturaAcompanhante)"
                  alt="Assinatura do Acompanhante" class="signature-image"
                  (click)="abrirModalFoto(servicoDetalhes.assinaturaAcompanhante?.url || servicoDetalhes.assinaturaAcompanhante)">
                <div *ngIf="!servicoDetalhes.assinaturaAcompanhante?.url && !servicoDetalhes.assinaturaAcompanhante"
                  class="sem-dados-campo">
                  Não informado
                </div>
              </div>
            </div>
          </fieldset>

          <fieldset>
            <legend class="mb-2">Dados do Vistoriador</legend>
            <div class="grid-2 mb-2">
              <div>
                <label>Nome:</label>
                <input type="text" class="form-control campo-readonly"
                  [value]="servicoDetalhes.nomeVistoriador || servicoDetalhes.nomeVistoriante || '-'" readonly>
              </div>
              <div>
                <label>Data da Vistoria:</label>
                <input type="text" class="form-control campo-readonly" [value]="servicoDetalhes.dataHoraInicio  ? 
                               (servicoDetalhes.dataHoraInicio | date: 'dd/MM/yyyy HH:mm') : '-'" readonly>
              </div>
            </div>
            <div class="grid-1 vistoriador-foto mb-2">
              <div>
                <label>Foto do Vistoriador:</label>
                <div class="foto-vistoriador">
                  <img *ngIf="servicoDetalhes.fotoVistoriador || servicoDetalhes.fotoVistoriante"
                    [src]="getFullImageUrl(servicoDetalhes.fotoVistoriador || servicoDetalhes.fotoVistoriante)"
                    alt="Foto do Vistoriador" class="foto-vistoriador"
                    (click)="abrirModalFoto(servicoDetalhes.fotoVistoriador || servicoDetalhes.fotoVistoriante)">
                  <div *ngIf="!servicoDetalhes.fotoVistoriador && !servicoDetalhes.fotoVistoriante"
                    class="sem-dados-campo">
                    Não disponível
                  </div>
                </div>
              </div>
            </div>
            <div>
              <label>Assinatura do Vistoriador:</label>
              <div class="signature-container">
                <img *ngIf="servicoDetalhes.assinaturaVistoriador || servicoDetalhes.assinaturaVistoriante?.url"
                  [src]="getFullImageUrl(servicoDetalhes.assinaturaVistoriador || servicoDetalhes.assinaturaVistoriante?.url)"
                  alt="Assinatura do Vistoriador" class="signature-image"
                  (click)="abrirModalFoto(servicoDetalhes.assinaturaVistoriador || servicoDetalhes.assinaturaVistoriante?.url)">
                <div *ngIf="!servicoDetalhes.assinaturaVistoriador && !servicoDetalhes.assinaturaVistoriante?.url"
                  class="sem-dados-campo">
                  Não informado
                </div>
              </div>
            </div>
          </fieldset>

          <!-- Campo moderno tipo carimbo para nome de quem analisou -->
          <div *ngIf="servicoDetalhes?.analisadoPorNome && (servicoDetalhes?.status === 'Validado' || servicoDetalhes?.status === 'Invalido')"
            class="d-flex justify-content-end mt-4">
            <span class="badge"
              [ngClass]="servicoDetalhes?.status === 'Validado' ? 'bg-success' : 'bg-danger'"
              style="font-size: 1.1rem; padding: 12px 28px; border-radius: 18px; box-shadow: 0 2px 8px rgba(0,0,0,0.15); letter-spacing: 0.5px; font-weight: 700; display: flex; flex-direction: column; align-items: flex-start; color: white;">
              <span>
                <i [ngClass]="servicoDetalhes?.status === 'Validado' ? 'bi bi-check-circle-fill' : 'bi bi-x-circle-fill'" class="me-2"></i>
                {{ servicoDetalhes?.status === 'Validado' ? 'VALIDADO' : 'INVALIDADO' }}
              </span>
              <span style="font-size: 0.95rem; font-weight: 500; margin-top: 6px; border-top: 1px solid rgba(255,255,255,0.3); padding-top: 6px; width: 100%;">
                <i class="bi bi-person-fill me-1"></i>
                Por: {{ servicoDetalhes.analisadoPorNome }}
              </span>
              <span *ngIf="servicoDetalhes.dataHoraInicioAnalise"
                style="font-size: 0.9rem; font-weight: 500; margin-top: 4px;">
                <i class="bi bi-calendar-check me-1"></i>
                Em: {{ servicoDetalhes.dataHoraInicioAnalise | date: 'dd/MM/yyyy HH:mm' }}
              </span>
            </span>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger me-2" (click)="exportarServicoParaPDF()">
          <i class="bi bi-file-earmark-pdf-fill me-1"></i> Exportar PDF
        </button>
        <button type="button" class="btn btn-secondary" (click)="fecharModalDetalhes()">Fechar</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal de visualização de foto ampliada -->
<div class="modal-foto" [class.show]="mostrarModalFoto" *ngIf="mostrarModalFoto" (click)="fecharModalFoto()">
  <div class="modal-foto-content" (click)="$event.stopPropagation()">
    <button type="button" class="btn-close-foto" (click)="fecharModalFoto()" aria-label="Fechar" title="Fechar">
      <i class="fas fa-times"></i>
    </button>
    <img [src]="getFullImageUrl(fotoSelecionada)" alt="Foto Ampliada" class="foto-ampliada"
      [style.transform]="'rotate(' + rotacaoFoto + 'deg)'"
      [style.transition]="'transform 0.3s'">
  </div>
</div>

<!-- Container oculto para exportação completa -->
<div #conteudoCompleto style="position: absolute; top: -9999px; left: -9999px; width: 1000px;">
  <div [innerHTML]="htmlCompletoParaExportar"></div>
</div>